import firebase from 'firebase/app'
import 'firebase/firestore'

let firebaseConfig= {};
if (process.env.NODE_ENV === 'production') {
     firebaseConfig = {
         apiKey: "AIzaSyCZCE6RB-FTx3UwtBhY2WKIzui12SRX-S8",
         authDomain: "wefix-production.firebaseapp.com",
         databaseURL: "https://wefix-production.firebaseio.com",
         projectId: "wefix-production",
         storageBucket: "wefix-production.appspot.com",
         messagingSenderId: "1006006010611",
         appId: "1:1006006010611:web:1200fd3b95c46861ecad86"
    };
} else {
    firebaseConfig = {
        apiKey: "AIzaSyAolh75hlDPUlxZEF7wNVTDD3LKKMPtOsc",
        authDomain: "sinuous-vortex-201512.firebaseapp.com",
        databaseURL: "https://sinuous-vortex-201512.firebaseio.com",
        projectId: "sinuous-vortex-201512",
        storageBucket: "sinuous-vortex-201512.appspot.com",
        messagingSenderId: "1060284197306",
        appId: "1:1060284197306:web:73c775b65b5dfa76c05583"
    };
}

// Get a Firestore instance
export const db = firebase
    .initializeApp(firebaseConfig)
    .firestore();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore;
export { Timestamp, GeoPoint }